import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { SketchPicker } from "react-color";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { withSnackbar } from "notistack";
import { LABELS, WARNINGS } from "common/lables";
import {
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Button,
  Popover,
} from "@mui/material";
import {
  ShareOutlined as ShareOutlinedIcon,
  ContentCopy as ContentCopyIcon,
  WhatsApp as WhatsAppIcon,
  MailOutlineOutlined as MailOutlineOutlinedIcon,
  BorderColor as BorderColorIcon,
  BorderColorOutlined as BorderColorOutlinedIcon,
  LayersClear as LayersClearIcon,
  ColorLens as ColorLensIcon,
  Square as SquareIcon,
} from "@mui/icons-material";
import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import { AUTH_APIs } from "apihandlers/auth";

const MapShare = (props: any) => {
  const { mapRef } = props;

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const isDrawing = useRef(false);
  const [color, setColor] = useState("#000000");
  const [thickness, setThickness] = useState(1);
  const [showShare, setShowShare] = useState<boolean>(false);
  const [copy, setCopy] = useState<boolean>(false);
  const [shareLink, setShareLink] = useState<boolean>(false);
  const [urlLink, setUrlLink] = useState<any>(null);
  const [imagePath, setImagePath] = useState<any>(null);
  const [popover, setPopver] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [drawing, setIsDrawing] = useState(false);

  const getColorPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setPopver(!popover);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setPopver(false);
  };

  const getColors = (color) => {
    setColor(color.hex);
  };

  const getShareLink = () => {
    const mapContainer = mapRef.current.leafletElement.getContainer();
    html2canvas(mapContainer).then(function (canvas) {
      const ctx = canvasRef.current?.getContext("2d");
      // Draw the captured image onto the canvas
      const img = new Image();
      img.src = canvas.toDataURL();
      img.onload = function () {
        if (ctx) {
          ctx.clearRect(
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
          );
          ctx.drawImage(
            img,
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
          );
        }
      };
      // Save the canvas reference
    });

    setShowShare(true);
  };

  const getCopiedLink = () => {
    setCopy(true);
  };

  // const downloadImage = () => {
  //   let canva = canvasRef.current;
  //   const canvaData = canva.toDataURL("image/png");
  //   const fileType = canvaData.split("base64,");
  //   const canvaFile = fileType[1];
  //   //   console.log("canvaData", canvaData, canvaFile);
  //   const link = document.createElement("a");
  //   link.href = canvaData;
  //   link.download = "canvas_image.png";
  //   link.click();
  // };

  //File uploads

  const onUploadFile = async () => {
    let canva = canvasRef.current;
    const base64Data = canva.toDataURL("image/png");
    setImagePath(base64Data);

    const args = {
      recordRefId: 1,
      file: {
        name: "",
        data: base64Data.replace("data:", "").replace(/^.+,/, ""),
        type: "image/png",
        mimeType: "",
        size: 0,
      },
      category: "aimap",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        //getfilepath
        let filePath = fileInfo.path;

        //convert into base64
        let fileEncode;
        if (typeof btoa === "function") {
          fileEncode = btoa(filePath);
        } else if (typeof Buffer === "function") {
          fileEncode = Buffer.from(filePath).toString("base64");
        } else {
          console.error("Base64 encoding not supported in this environment.");
        }
        console.log("fileEncode", fileEncode);
        //create new share url by adding base64 as q
        const shareUrl = `http://localhost:3000/sharePage?q=${fileEncode}`;
        console.log("shareUrl", shareUrl, window.location.href, fileEncode);
        setUrlLink(shareUrl);
        // window.open(shareUrl, "_blank");
        //open the url get the query param decode it to normal text
      }
    } catch (error) {}
    setShareLink(true);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    const mapContainer = mapRef.current.leafletElement.getContainer();

    if (ctx && canvas && mapContainer) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // Redraw the map content (or any other content you want to retain)
      html2canvas(mapContainer).then((capturedCanvas) => {
        ctx.drawImage(capturedCanvas, 0, 0);
      });
    }
  };

  const handleDrawing = () => {
    setIsDrawing((prevState) => !prevState); // Toggle the drawing state
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");

    const adjustCoordinates = (e: MouseEvent) => {
      console.log("event111", e);
      const rect = canvas?.getBoundingClientRect();
      if (rect) {
        return {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        };
      }
      return { x: 0, y: 0 };
    };

    const startDrawing = (e: MouseEvent) => {
      console.log("event222", e);
      if (!drawing) return; // Check the 'isDrawing' state
      e.preventDefault();
      isDrawing.current = true;
      const { x, y } = adjustCoordinates(e);
      if (ctx) {
        ctx.beginPath();
        ctx.moveTo(x, y);
      }
    };

    const draw = (e: MouseEvent) => {
      console.log("event333", e);
      if (!isDrawing.current) return; // Check the 'isDrawing' state
      const { x, y } = adjustCoordinates(e);
      if (ctx) {
        ctx.lineTo(x, y);
        ctx.strokeStyle = color;
        ctx.lineWidth = thickness;
        ctx.stroke();
      }
    };

    const stopDrawing = () => {
      isDrawing.current = false;
    };

    canvas?.addEventListener("mousedown", startDrawing);
    canvas?.addEventListener("mousemove", draw);
    canvas?.addEventListener("mouseup", stopDrawing);
    canvas?.addEventListener("mouseout", stopDrawing);

    return () => {
      canvas?.removeEventListener("mousedown", startDrawing);
      canvas?.removeEventListener("mousemove", draw);
      canvas?.removeEventListener("mouseup", stopDrawing);
      canvas?.removeEventListener("mouseout", stopDrawing);
    };
  }, [drawing, color, thickness]);

  const getWhatsAppWeb = () => {
    window.open(`https://api.whatsapp.com/send?text=  ${[urlLink]} `);
  };

  const shareLinkViaEmail = () => {
    const title = "Your post title";
    const gmailLink = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=&su=${title}&body=${urlLink}`;
    window.open(gmailLink);
  };

  const getDefaults = () => {
    setColor("#000000");
    setThickness(1);
    setIsDrawing(false);
  };

  return (
    <>
      <div
        className="leftSideFilterOptions"
        style={{ top: "4rem" }}
        onClick={getShareLink}
      >
        <Tooltip title={LABELS.SHARE} placement="right" arrow={true}>
          <ListItemButton>
            <ListItemIcon>
              <ShareOutlinedIcon />
            </ListItemIcon>
          </ListItemButton>
        </Tooltip>
      </div>
      {showShare && (
        <UiDialog
          title={LABELS.SHARE}
          open={true}
          size={"xl"}
          onClose={() => {
            setShowShare(false);
            setShareLink(false);
            setCopy(false);
            getDefaults();
          }}
          draggable={false}
        >
          <div className="shareDialogueBox">
            {shareLink ? (
              <div>
                <h3>{LABELS.SHARE_IMAGE}</h3>
              </div>
            ) : (
              <div className="editBox">
                <div style={{ marginLeft: "0.8rem" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    startIcon={
                      drawing ? (
                        <BorderColorIcon />
                      ) : (
                        <BorderColorOutlinedIcon />
                      )
                    }
                    onClick={handleDrawing}
                  >
                    {LABELS.DRAW}
                  </Button>
                </div>
                {/* <div></div> */}
                <div style={{ marginLeft: "0.8rem" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    startIcon={<ColorLensIcon />}
                    onClick={getColorPopover}
                    endIcon={
                      <SquareIcon
                        fontSize="medium"
                        sx={{ color: `${color}` }}
                      />
                    }
                  >
                    {LABELS.COLOR}
                  </Button>
                </div>
                <div>
                  <div style={{ marginLeft: "0.3rem" }}>
                    <Button
                      color="primary"
                      variant="outlined"
                      startIcon={<LayersClearIcon />}
                      onClick={clearCanvas}
                    >
                      {LABELS.CLEAR}
                    </Button>
                  </div>
                </div>
                <div>
                  <Popover
                    open={popover}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <SketchPicker color={color} onChange={getColors} />
                  </Popover>
                </div>
                <div className="Thickness">
                  <div>
                    <label>{LABELS.THICKNESS}</label>
                  </div>
                  <div style={{ width: "13rem" }}>
                    <input
                      type="range"
                      min="1"
                      max="100"
                      value={thickness}
                      onChange={(e) =>
                        setThickness(parseInt(e.target.value, 10))
                      }
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div>
                    <span>{thickness + "%"}</span>
                  </div>
                </div>
              </div>
            )}

            <div>
              {shareLink ? (
                <div className="shareImg">
                  {" "}
                  <img
                    src={imagePath}
                    alt="Captured Image"
                    className="capImg"
                  />
                </div>
              ) : (
                <canvas
                  ref={canvasRef}
                  id="myCanvas"
                  width="1485"
                  height="650"
                  className="canvaImg"
                ></canvas>
              )}
            </div>
            {shareLink === false && (
              <div className="shareButtonSave">
                <div style={{ marginTop: "0.5rem" }}>
                  <Btn text={LABELS.SAVE} onClick={onUploadFile}></Btn>
                </div>
              </div>
            )}
            {shareLink && (
              <>
                <div style={{ marginTop: "0.8rem" }}>
                  <div className="socialShare ">
                    <div className="formGroup width60 ">
                      <TxtBox value={urlLink}></TxtBox>
                    </div>
                  </div>
                  <div className="socialShare">
                    <div className="shareBtns">
                      <div>
                        <CopyToClipboard text={urlLink} onCopy={getCopiedLink}>
                          <Button
                            color="primary"
                            variant="contained"
                            startIcon={<ContentCopyIcon />}
                            disabled={copy ? true : false}
                          >
                            {copy ? LABELS.COPIED : LABELS.COPY}
                          </Button>
                        </CopyToClipboard>
                      </div>
                      <div style={{ marginLeft: "1rem" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          startIcon={<MailOutlineOutlinedIcon />}
                          onClick={shareLinkViaEmail}
                        >
                          {LABELS.EMAIL}
                        </Button>
                      </div>
                      <div style={{ marginLeft: "1rem" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          startIcon={<WhatsAppIcon />}
                          onClick={getWhatsAppWeb}
                        >
                          {LABELS.WHATSAPP}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </UiDialog>
      )}
      {/* <SharePage
        setUrlLink={(val: any) => {
          setUrlLink(val);
        }}
      /> */}
    </>
  );
};

export default withSnackbar(MapShare);
